import _ from "lodash";
import { CollectionAsset } from "src/types/collections";

export const calculateDimensionsForCard = (gridRef, index, restoreDefaultLayout, isContactCard) => {
  const modValue = index % 10;
  const baseRow = Math.floor(index / 10);
  const baseY = baseRow * 4;

  const dimensions = [
    { width: 3, height: 2, x: 0, yOffset: 0 }, // 0
    { width: 1, height: 2, x: 3, yOffset: 0 }, // 1
    { width: 1, height: 1, x: 4, yOffset: 0 }, // 2
    { width: 1, height: 1, x: 5, yOffset: 0 }, // 3 
    { width: 2, height: 1, x: 4, yOffset: 1 }, // 4
    { width: 2, height: 1, x: 0, yOffset: 2 }, // 5
    { width: 1, height: 2, x: 2, yOffset: 2 }, // 6
    { width: 2, height: 2, x: 3, yOffset: 2 }, // 7 
    { width: 1, height: 2, x: 5, yOffset: 2 }, // 8
    { width: 2, height: 1, x: 0, yOffset: 3 }  // 9
  ];

  const { width, x, yOffset } = dimensions[modValue];

  const height = isContactCard ? 1 : dimensions[modValue].height;

  let y = yOffset + baseY;
  
  if(restoreDefaultLayout){
    return { x: x, y: y, width: width, height: height }
  }

  if (gridRef) {
    if (!gridRef.isAreaEmpty(x, y, width, height)) {
      let newYOffset = 0;
      do {
        newYOffset++;
      } while (!gridRef.isAreaEmpty(x, newYOffset, width, height));
      y = newYOffset;
    }
  }

  return { xaxis: x, yaxis: y, width: width, height: height }
}

export const getAssetHasDimensions = (asset: CollectionAsset) => {
  const requiredMetadataProperties = ["xaxis", "yaxis", "width", "height"];
  
  const metadata = _.get(asset, "metadata");

  if (!metadata) {
    return false;
  }

  const assetMetadataProperties = Object.keys(metadata);

  const includesRequiredMetadataProperties = requiredMetadataProperties.map((requiredMetadataProperty: string) => {
    return assetMetadataProperties.includes(requiredMetadataProperty);
  });

  const hasNonZeroHeightOrWidth = _.get(metadata, "height") !== 0 && _.get(metadata, "height") !== 0;

  return _.every(includesRequiredMetadataProperties) && hasNonZeroHeightOrWidth;
}